import Item from './Item';
import { useDrop } from 'react-dnd';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { Typography, Tooltip, Chip, Grid } from '@material-ui/core';

const ItemTypes = {
	ITEM: 'item',
};

export default function Tree({
	items,
	parent,
	move,
	find,
	indexParent,
	hasGrouping = { status: false, groups: [] },
	mainAction = (e) => {},
	onItemView,
	onItemFiles,
	onItemDelete,
	onItemDetail,
	canEdit,
}) {
	const [{ isOver }, drop] = useDrop({
		accept: ItemTypes.ITEM,
		drop: (props, monitor) => {},
		hover: (props, monitor) => getMoving(props, monitor),
		collect: (monitor) => ({
			isOver: !!monitor.isOver(),
		}),
	});
	function getMoving(props, monitor) {
		if (!monitor.isOver({ shallow: true })) return;
		const descendantNode = find(parent, props.subItems);
		if (descendantNode) return;
		if (props.parent === parent || props.id === parent) return;

		move(props.id, undefined, parent);
	}

	return (
		<div
			ref={drop}
			style={{
				position: 'relative',
				minHeight: 5,
				paddingTop: 5,
				marginLeft: '1em',
				backgroundColor: isOver ? '#ffffff' : '#ffffff',
				display: 'flex',
				flexDirection: 'column',
			}}
		>
			{hasGrouping.status ? (
				hasGrouping.groups.map((group) => (
					<Grid item key={`chip-${group.title}`}>
						<div style={{ width: '50%', marginBottom: '3px' }}>
							<Chip
								color="secondary"
								label={
									<Typography variant="h6">{group.title}</Typography>
								}
								onDelete={
									canEdit === false
										? () => {}
										: () => mainAction(group.title)
								}
								variant="outlined"
								deleteIcon={
									<Tooltip title="Agregar nuevo punto a la orden del día">
										<AddCircleIcon />
									</Tooltip>
								}
							/>
						</div>
						{group.data.map((item, i) => (
							<Item
								key={item.id}
								id={item.id}
								parent={parent}
								item={item}
								move={move}
								find={find}
								index={item.order}
								indexParent={indexParent}
								onDetail={canEdit ? onItemView : ''}
								onDelete={canEdit ? onItemDelete : ''}
								onFile={onItemFiles}
								onView={onItemDetail}
							/>
						))}
					</Grid>
				))
			) : items.length > 0 ? (
				<>
					{items?.map((subItems, i) => {
						return (
							<Item
								key={subItems.id}
								id={subItems.id}
								parent={parent}
								item={subItems}
								move={move}
								find={find}
								index={i + 1}
								indexParent={indexParent}
								onDetail={onItemView}
								onDelete={onItemDelete}
								onFile={onItemFiles}
								onView={onItemDetail}
							/>
						);
					})}
				</>
			) : (
				'Sin resultados en la relación'
			)}
		</div>
	);
}
